import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { projectApi } from '../api';
import { Flex, Button, Modal, Tabs } from 'antd';
import { EditOutlined, LinkOutlined } from '@ant-design/icons';
import ProjectPopup from '../projectPages/ProjectPopup';
import ProjectArtifacts from '../projectPages/ProjectArtifacts';
import ResourcePlan from '../projectPages/ResourcePlan';
import {userRole} from '../../GetRole.utils';

const ProjectsDetail = () => {
  const [projectData, setProjectData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetchData();
  }, [id, isModalOpen]);

  const fetchData = async () => {
    try {
      const response = await projectApi.getProjectData(id, 1);
      const project = response.data.data[0];
      setProjectData({
        projectName: project.projectName,
        projectDescription: project.projectDescription,
        legalEntityName: project.client.legalEntityName,
        clientId: project?.client?.clientId,
        updated_at: project.updatedAt,
      });
    } catch (error) {
      console.log('Error fetching data:', error);
    }
  };

  return (
    <Flex vertical gap={16}>
      <Flex vertical className="clientDetailTile" gap={10}>
        <Flex justify="space-between" align="center">
          <h3 style={{ margin: '10px 0' }}>Project Details</h3>
          {userRole !== 'finance' && (
            <Button
              onClick={() => setIsModalOpen(true)}
              type="primary"
              icon={<EditOutlined />}
            >
              EDIT
            </Button>
          )}
          <Modal
            title='Edit Engagement/Project'
            key={isModalOpen ? 'open' : 'closed'}
            open={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            footer={null}
          >
            <ProjectPopup
              hide={setIsModalOpen}
              isModalOpen={isModalOpen}
              buttonText={'Update'}
              clientId={id}
            />
          </Modal>
        </Flex>

        <Flex>
          <span className="label">Entity Name : &nbsp;</span>{' '}
          <span
            onClick={() => navigate(`/clients/${projectData.clientId}`)}
            style={{ cursor: 'pointer', color: '#000000' }}
          >
            {projectData.legalEntityName} &nbsp;
            <a>
              <LinkOutlined />
            </a>
          </span>
        </Flex>

        <Flex>
          <span className="label">Project Name : &nbsp;</span>{' '}
          <span>{projectData.projectName}</span>
        </Flex>

        <Flex style={{ overflowX: 'auto' }}>
          <span className="label">
            Project Description : &nbsp;
          </span>{' '}
          <span
            className="description-container popupDiv"
            style={{ width: '65%', maxHeight: '4em', overflow: 'auto' }}
          >
            {projectData.projectDescription}
          </span>{' '}
        </Flex>
        <Flex>
          <span className="label">Last Updated On : &nbsp;</span>{' '}
          <span>{projectData.updated_at}</span>{' '}
        </Flex>
      </Flex>

      <Tabs
        defaultActiveKey="artifacts"
        items={[
          {
            key: 'artifacts',
            label: 'Artifacts',
            children: (
              <Flex vertical className="clientDetailTile" gap={10}>
                <ProjectArtifacts projectId={id} />
              </Flex>
            ),
          },
          {
            key: 'resources',
            label: 'Resource plan',
            children: (
              <Flex vertical className="clientDetailTile" gap={10}>
                <ResourcePlan projectId={id} />
              </Flex>
            ),
          },
        ]}
      />
    </Flex>
  );
};

export default ProjectsDetail;
